import React, { useState, useRef, useEffect } from 'react';
import { FaComments, FaTimes, FaPaperPlane, FaMinus } from 'react-icons/fa';
import './Chatbot.css';

const BOT_NAME = 'Mascot';

const QA = [
  {
    patterns: ['hello', 'hi', 'hey', 'good morning', 'good afternoon', 'good evening', 'greetings'],
    answer: "Hello! 👋 Welcome to Techmascot Technologies. I'm Mascot, your virtual assistant. How can I help you today?",
    quickReplies: ['Our Services', 'Contact Us', 'About Techmascot', 'Get a Quote'],
  },
  {
    patterns: ['service', 'services', 'what do you do', 'offerings', 'what you offer'],
    answer: "We offer cutting-edge fintech solutions:\n\n💳 Payment Gateway Solutions\n🤝 Escrow Payment Systems\n🔄 Reconciliation Engine\n📊 Finance Applications\n☁️ Cloud Services\n🔗 API Integration Services\n\nWhich service would you like to know more about?",
    quickReplies: ['Payment Gateway', 'Escrow Systems', 'Cloud Services', 'API Integration'],
  },
  {
    patterns: ['payment gateway', 'payment solution', 'payment'],
    answer: "Our **Payment Gateway Solutions** include:\n\n✅ Multi-currency & multi-bank support\n✅ UPI, Net Banking, Cards & Wallets\n✅ Real-time transaction monitoring\n✅ PCI DSS Level 1 compliance\n✅ 99.99% uptime SLA\n✅ Fraud detection & chargeback management\n\nWant to discuss your payment requirements?",
    quickReplies: ['Get a Quote', 'Contact Us', 'Other Services'],
  },
  {
    patterns: ['escrow', 'escrow payment', 'escrow system'],
    answer: "Our **Escrow Payment Systems** provide:\n\n✅ Conditional fund release logic\n✅ Multi-party escrow workflows\n✅ Milestone-based disbursements\n✅ Dispute resolution engine\n✅ KYC/AML verification built-in\n✅ Audit trail & compliance reports\n\nPerfect for secure B2B and marketplace transactions.",
    quickReplies: ['Get a Quote', 'Contact Us', 'Other Services'],
  },
  {
    patterns: ['reconciliation', 'reconciliation engine'],
    answer: "Our **Reconciliation Engine** offers:\n\n✅ Multi-source data ingestion\n✅ Intelligent transaction matching\n✅ Real-time & batch reconciliation\n✅ Settlement processing automation\n✅ ERP & accounting system integration\n✅ Analytics & exception reporting",
    quickReplies: ['Get a Quote', 'Contact Us', 'Other Services'],
  },
  {
    patterns: ['cloud', 'cloud service', 'cloud services'],
    answer: "Our **Cloud Services** cover:\n\n✅ AWS, Azure & GCP expertise\n✅ PCI DSS cloud architecture\n✅ Zero-downtime migration\n✅ Kubernetes & container orchestration\n✅ CI/CD pipeline setup\n✅ Cost optimization & FinOps\n✅ Disaster recovery planning",
    quickReplies: ['Get a Quote', 'Contact Us', 'Other Services'],
  },
  {
    patterns: ['api', 'api integration', 'integration'],
    answer: "Our **API Integration Services** include:\n\n✅ Bank API integrations (CBS, SFMS)\n✅ Payment network connectivity\n✅ NPCI & RBI system integrations\n✅ RESTful & SOAP API development\n✅ API gateway & rate limiting\n✅ SDK development & documentation",
    quickReplies: ['Get a Quote', 'Contact Us', 'Other Services'],
  },
  {
    patterns: ['finance', 'finance application', 'finance app', 'financial'],
    answer: "Our **Finance Applications** include:\n\n✅ Lending & loan management systems\n✅ Treasury & cash flow management\n✅ Investment portfolio tracking\n✅ Financial reporting & analytics\n✅ Regulatory compliance dashboards\n✅ Risk assessment engines",
    quickReplies: ['Get a Quote', 'Contact Us', 'Other Services'],
  },
  {
    patterns: ['contact', 'reach', 'get in touch', 'talk', 'speak', 'email', 'phone'],
    answer: "You can reach us through:\n\n📧 Email: info@techmascot.in\n🌐 Website: www.techmascot.in\n📱 WhatsApp: +917903567473\n\nOr visit our Contact page and fill out the form — we respond within 24 hours!",
    quickReplies: ['Get a Quote', 'Our Services', 'About Techmascot'],
  },
  {
    patterns: ['about', 'who are you', 'company', 'techmascot', 'about you'],
    answer: "**Techmascot Technologies Pvt. Ltd.** is a specialist fintech engineering company.\n\n🏢 We build payment infrastructure, financial platforms, and cloud solutions for businesses across industries.\n\n🎯 Our mission: Deliver secure, scalable & compliant fintech systems that drive financial innovation.\n\n💡 Motto: Innovate. Develop. Elevate.",
    quickReplies: ['Our Services', 'Contact Us', 'Industries We Serve'],
  },
  {
    patterns: ['industry', 'industries', 'sector', 'who do you serve'],
    answer: "We serve a wide range of industries:\n\n🏦 Banking & Finance\n🛒 E-Commerce & Retail\n🏥 Healthcare\n🎓 Education\n🏭 Manufacturing\n🚚 Logistics\n🏛️ Government\n📡 Telecom\n\nWe tailor our solutions to each industry's unique compliance and operational needs.",
    quickReplies: ['Our Services', 'Contact Us', 'Get a Quote'],
  },
  {
    patterns: ['quote', 'pricing', 'cost', 'price', 'how much', 'get started', 'start'],
    answer: "We'd love to discuss your project! 🚀\n\nTo get a customized quote:\n\n1️⃣ Visit our Contact page\n2️⃣ Fill in your project details\n3️⃣ Our team will respond within 24 hours\n\nOr reach us directly at info@techmascot.in",
    quickReplies: ['Contact Us', 'Our Services', 'About Techmascot'],
  },
  {
    patterns: ['security', 'secure', 'compliance', 'pci', 'safe'],
    answer: "Security is at our core:\n\n🔒 PCI DSS Level 1 compliant\n🛡️ End-to-end encryption\n🔐 KYC/AML verification\n📋 Regulatory compliance frameworks\n🕵️ Fraud detection & prevention\n📊 Real-time security monitoring\n\nYour data and transactions are always protected.",
    quickReplies: ['Our Services', 'Contact Us', 'Get a Quote'],
  },
  {
    patterns: ['thank', 'thanks', 'thank you', 'great', 'awesome', 'helpful'],
    answer: "You're welcome! 😊 It was a pleasure assisting you. Feel free to reach out anytime.\n\nIs there anything else I can help you with?",
    quickReplies: ['Our Services', 'Contact Us', 'Get a Quote'],
  },
  {
    patterns: ['bye', 'goodbye', 'see you', 'ciao', 'take care'],
    answer: "Goodbye! 👋 Thank you for visiting Techmascot Technologies. Have a great day! Feel free to come back anytime.",
    quickReplies: [],
  },
];

const DEFAULT_RESPONSE = {
  answer: "I'm not sure I understood that. 🤔 Could you try rephrasing, or choose one of the options below?",
  quickReplies: ['Our Services', 'Contact Us', 'About Techmascot', 'Get a Quote'],
};

const WELCOME_MESSAGE = {
  id: 1,
  from: 'bot',
  text: "👋 Hi there! I'm **Mascot**, Techmascot's virtual assistant.\n\nHow can I help you today?",
  quickReplies: ['Our Services', 'Contact Us', 'About Techmascot', 'Get a Quote'],
};

function findAnswer(input) {
  const lower = input.toLowerCase().trim();
  for (const qa of QA) {
    if (qa.patterns.some(p => lower.includes(p))) {
      return qa;
    }
  }
  return DEFAULT_RESPONSE;
}

function formatText(text) {
  return text
    .split('\n')
    .map((line, i) => {
      const bold = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      return `<span key="${i}">${bold}</span>`;
    })
    .join('<br/>');
}

let msgId = 2;

function Chatbot() {
  const [open, setOpen] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [messages, setMessages] = useState([WELCOME_MESSAGE]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const [unread, setUnread] = useState(0);
  const bottomRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setUnread(0);
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [open]);

  useEffect(() => {
    if (open && !minimized) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, typing, open, minimized]);

  const sendMessage = (text) => {
    const userText = text || input.trim();
    if (!userText) return;

    const userMsg = { id: msgId++, from: 'user', text: userText };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setTyping(true);

    setTimeout(() => {
      const response = findAnswer(userText);
      const botMsg = {
        id: msgId++,
        from: 'bot',
        text: response.answer,
        quickReplies: response.quickReplies || [],
      };
      setTyping(false);
      setMessages(prev => [...prev, botMsg]);
      if (!open) setUnread(prev => prev + 1);
    }, 900);
  };

  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <>
      {/* Floating Button */}
      <button
        className={`chatbot-fab ${open ? 'active' : ''}`}
        onClick={() => { setOpen(!open); setMinimized(false); }}
        aria-label="Open chat"
      >
        {open ? <FaTimes /> : <FaComments />}
        {!open && unread > 0 && <span className="chatbot-badge">{unread}</span>}
      </button>

      {/* Chat Window */}
      {open && (
        <div className={`chatbot-window ${minimized ? 'minimized' : ''}`}>
          {/* Header */}
          <div className="chatbot-header">
            <div className="chatbot-header-info">
              <div className="chatbot-avatar">M</div>
              <div>
                <div className="chatbot-name">{BOT_NAME}</div>
                <div className="chatbot-status">
                  <span className="chatbot-dot" />
                  Online
                </div>
              </div>
            </div>
            <div className="chatbot-header-actions">
              <button onClick={() => setMinimized(!minimized)} aria-label="Minimize">
                <FaMinus />
              </button>
              <button onClick={() => setOpen(false)} aria-label="Close">
                <FaTimes />
              </button>
            </div>
          </div>

          {/* Body */}
          {!minimized && (
            <>
              <div className="chatbot-body">
                {messages.map((msg) => (
                  <div key={msg.id} className={`chatbot-msg-row ${msg.from}`}>
                    {msg.from === 'bot' && (
                      <div className="chatbot-msg-avatar">M</div>
                    )}
                    <div className="chatbot-msg-wrap">
                      <div
                        className={`chatbot-bubble ${msg.from}`}
                        dangerouslySetInnerHTML={{ __html: formatText(msg.text) }}
                      />
                      {msg.quickReplies && msg.quickReplies.length > 0 && (
                        <div className="chatbot-quick-replies">
                          {msg.quickReplies.map((qr) => (
                            <button
                              key={qr}
                              className="chatbot-chip"
                              onClick={() => sendMessage(qr)}
                            >
                              {qr}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                {typing && (
                  <div className="chatbot-msg-row bot">
                    <div className="chatbot-msg-avatar">M</div>
                    <div className="chatbot-bubble bot typing">
                      <span /><span /><span />
                    </div>
                  </div>
                )}
                <div ref={bottomRef} />
              </div>

              {/* Input */}
              <div className="chatbot-footer">
                <input
                  ref={inputRef}
                  type="text"
                  className="chatbot-input"
                  placeholder="Type a message..."
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleKey}
                />
                <button
                  className="chatbot-send"
                  onClick={() => sendMessage()}
                  disabled={!input.trim()}
                  aria-label="Send"
                >
                  <FaPaperPlane />
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}

export default Chatbot;
